import { ConfigureRackBOMOverrideState, SelectComponent } from "../../../interfaces/configureRackBOMOverrideInterfaces";
import { DEFAULT_PREFERENCES } from "../../../pages/UnifiedMovementSystem/ConfigureRackBOMOverride/components/PreferencesComponent";
import { UPDATE_AFG_DATA, UPDATE_AFG_TABLE_DATA, UPDATE_CATEGORY_OPTIONS, UPDATE_CONFIGURE_OVERRIDE_MODAL, UPDATE_DEPARTMENT_OPTIONS, UPDATE_DISCONNECT_AFG, UPDATE_DISCONNECT_UPCOMING_AFG_MODAL, UPDATE_DROPDOWN_LOADING, UPDATE_EXTERNAL_RACK_TYPE_OPTIONS, UPDATE_INTERNAL_RACK_TYPE_OPTIONS, UPDATE_LOAD_MORE_BUTTON_CLICKED, UPDATE_PREFERENCES, UPDATE_RACK_IPN_OPTIONS, UPDATE_SCROLL_ID, UPDATE_SEARCH_FIELD_ERROR, UPDATE_SEARCH_TEXT, UPDATE_SELECTED_CATEGORY, UPDATE_SELECTED_DEPARTMENT, UPDATE_SELECTED_EXTERNAL_RACK_TYPE, UPDATE_SELECTED_INTERNAL_RACK_TYPE, UPDATE_SELECTED_ITEMS, UPDATE_SELECTED_RACK_IPN, UPDATE_SELECTED_RACK_TYPE, UPDATE_SELECTED_STATUS_FIELD, UPDATE_TYPE } from "../types/configureRackBOMOverrideTypes";

const initialState: ConfigureRackBOMOverrideState = {
    selectedStatusField: [],
    selectedRackIpn: [],
    selectedDepartment: [],
    selectedCategory: [],
    selectedRackType: [],
    selectedExternalRackType: [],
    selectedInternalRackType: [],
    searchText: "",
    searchFieldError: false,
    showConfigureOverrideModal: false,
    showDisconnectAllAndUpcomingAFGsModal: false,
    scrollId: "",
    isDropDownLoading: true,
    isLoadMoreButtonClicked: false,
    isAfgDataUpdateInProgress: null,
    isDisconnectAfgInProgress: null,
    afgTableData: [],
    selectedItems: [],
    preferences: DEFAULT_PREFERENCES,
    updateType: "",
    categoryOptions: [],
    rackIpnOptions: [],
    externalRackTypeOptions: [],
    internalRackTypeOptions: [],
    departmentOptions: []
}

export const configureRackBOMOverrideReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case UPDATE_SELECTED_STATUS_FIELD:
            return {
                ...state,
                selectedStatusField: action.payload as SelectComponent[]
            }
        case UPDATE_SELECTED_RACK_IPN: 
            return {
                ...state,
                selectedRackIpn: action.payload as SelectComponent[]
            }
        case UPDATE_SELECTED_DEPARTMENT: 
            return {
                ...state,
                selectedDepartment: action.payload as SelectComponent[]
            }
        case UPDATE_SELECTED_CATEGORY:
            return {
                ...state,
                selectedCategory: action.payload as SelectComponent[]
            
            }
        case UPDATE_SELECTED_RACK_TYPE: 
            return {
                ...state,
                selectedRackType: action.payload as SelectComponent[]
            }
        case UPDATE_SELECTED_EXTERNAL_RACK_TYPE:
            return {
                ...state,
                selectedExternalRackType: action.payload as SelectComponent[]
            }
        case UPDATE_SELECTED_INTERNAL_RACK_TYPE:
            return {
                ...state,
                selectedInternalRackType: action.payload as SelectComponent[]
            }
        case UPDATE_SEARCH_TEXT: 
            return {
                ...state,
                searchText: action.payload as string
            }
        case UPDATE_SEARCH_FIELD_ERROR:
            return {
                ...state,
                searchFieldError: action.payload as boolean
            }
        case UPDATE_CONFIGURE_OVERRIDE_MODAL:
            return {
                ...state,
                showConfigureOverrideModal: action.payload as boolean
            }
        case UPDATE_DISCONNECT_UPCOMING_AFG_MODAL:
            return {
                ...state,
                showDisconnectAllAndUpcomingAFGsModal: action.payload as boolean
            }
        case UPDATE_SCROLL_ID:
            return {
                ...state,
                scrollId: action.payload as string
            }
        case UPDATE_DROPDOWN_LOADING:
            return {
                ...state,
                isDropDownLoading: action.payload as boolean
            }
        case UPDATE_LOAD_MORE_BUTTON_CLICKED:
            return {
                ...state,
                isLoadMoreButtonClicked: action.payload as boolean
            }
        case UPDATE_AFG_DATA:
            return {
                ...state,
                isAfgDataUpdateInProgress: action.payload as boolean
            }
        case UPDATE_DISCONNECT_AFG: 
            return {
                ...state,
                isDisconnectAfgInProgress: action.payload as boolean
            }
        case UPDATE_AFG_TABLE_DATA:
            return {
                ...state,
                afgTableData: action.payload as any
            }
        case UPDATE_SELECTED_ITEMS:
            return {
                ...state,
                selectedItems: action.payload as any
            }
        case UPDATE_PREFERENCES:
            return {
                ...state,
                preferences: action.payload as any
            }
        case UPDATE_TYPE: 
            return {
                ...state,
                updateType: action.payload as string
            }
        case UPDATE_CATEGORY_OPTIONS:
            return {
                ...state,
                categoryOptions: action.payload as any
            }
        case UPDATE_RACK_IPN_OPTIONS:
            return {
                ...state,
                rackIpnOptions: action.payload as any
            }
        case UPDATE_EXTERNAL_RACK_TYPE_OPTIONS:
            return {
                ...state,
                externalRackTypeOptions: action.payload as any
            }
        case UPDATE_INTERNAL_RACK_TYPE_OPTIONS:
            return {
                ...state,
                internalRackTypeOptions: action.payload as any
            }
        case UPDATE_DEPARTMENT_OPTIONS:
            return {
                ...state,
                departmentOptions: action.payload as any
            }
        default:
            return state;
    }
}